import React from 'react';
import { Box, Button, TextField } from '@mui/material';

const SessionDiscussionEditor = ({
  sessionId,
  newMessage,
  setNewMessage,
  onSendComplete,
  moduleName
}) => {
  const handleSendMessage = () => {
    if (!newMessage) return;

    const discussionPayload = {
      message: newMessage,
      sender: 'user',
      module: moduleName || 'cards',
    };
    console.log('[Planner] discussion payload:', discussionPayload);

    // Send message to discussion with module included
    fetch(`/api/planner-sessions/${sessionId}/discussion`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(discussionPayload),
    })
      // Optionally trigger agent reply
      .then(() => {
        const agentPayload = {
          message: newMessage,
          module: moduleName || 'cards',
        };
        console.log('[Planner] agent-reply payload:', agentPayload);

        return fetch(`/api/planner-sessions/${sessionId}/agent-reply`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(agentPayload),
        });
      })
      // Log agent reply back into discussion
      .then(response => response.json())
      .then(data => {
        const agentMessage = data.message;
        return fetch(`/api/planner-sessions/${sessionId}/discussion`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message: agentMessage, sender: 'agent', module: moduleName || 'cards' }),
        });
      })
      .then(() => {
        setNewMessage('');
        if (onSendComplete) onSendComplete();
      })
      .catch(err => {
        console.error('Failed to send message', err);
      });
  };

  return (
    <Box mt={2} display="flex" gap={1}>
      <TextField
        fullWidth
        label="Type your message"
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        variant="outlined"
      />
      <Button onClick={handleSendMessage} variant="contained" color="primary">
        Send
      </Button>
    </Box>
  );
};

export default SessionDiscussionEditor;
